import * as trendActionTypes from 'js/constants/trendAction-Types';

function trendReducer(
  state = {
    trendConsume: [],
    trendDemand: [],
    trendLoadFactor: [],
    trendAverage: [],
    trendCo2: [],
  },
  action
) {
  switch (action.type) {
    case trendActionTypes.SHOW_TREND_CONSUME_SUCCESS:
      return { ...state, trendConsume: action.payload };
    case trendActionTypes.SHOW_TREND_CONSUME_FAILURE:
      return { ...state, error: action.state.error };
    case trendActionTypes.SHOW_TREND_DEMAND_SUCCESS:
      return { ...state, trendDemand: action.payload };
    case trendActionTypes.SHOW_TREND_DEMAND_FAILURE:
      return { ...state, error: action.state.error };
    case trendActionTypes.SHOW_TREND_LOAD_FACTOR_SUCCESS:
      return { ...state, trendLoadFactor: action.payload };
    case trendActionTypes.SHOW_TREND_LOAD_FACTOR_FAILURE:
      return { ...state, error: action.state.error };
    case trendActionTypes.SHOW_TREND_AVERAGE_SUCCESS:
      return { ...state, trendAverage: action.payload };
    case trendActionTypes.SHOW_TREND_AVERAGE_FAILURE:
      return { ...state, error: action.state.error };
    case trendActionTypes.SHOW_TREND_CO2_SUCCESS:
      return { ...state, trendCo2: action.payload };
    case trendActionTypes.SHOW_TREND_CO2_FAILURE:
      return { ...state, error: action.state.error };
    default:
      return state;
  }
}

export default trendReducer;
